/* eslint-disable */
// This file is generated by scripts/build-event-contract.mjs from
// contracts/events/analytics.v1.schema.json. Do not edit by hand.

export const ANALYTICS_EVENT_NAMES = [
  "content:guide_navigation_clicked",
  "content:guide_viewed",
  "content:official_source_clicked",
  "content:guide_index_selected",
  "content:guide_cta_clicked",
  "course_added",
  "course_removed",
  "course_sniper:alert_action",
  "course_sniper:webreg_handoff",
  "landing_cta_click",
  "landing_module_tab_click",
  "onboarding:completed",
  "onboarding:skipped",
  "optimal_setup:shown",
  "optimal_setup:previewed",
  "optimal_setup:education_shown",
  "optimal_setup:system_prompt",
  "optimal_setup:choice",
  "optimal_setup:permission_choice",
  "optimal_setup:handoff",
  "optimal_setup:outcome",
  "optimal_setup:completed",
  "scarlet_search",
  "schedule:saved",
  "schedule_generated",
  "search:result_selected",
  "assistant:skill_observed",
  "transcript:import_confirmed",
  "user_logged_in"
] as const;

export type AnalyticsEventName = (typeof ANALYTICS_EVENT_NAMES)[number];

export type AnalyticsEventPropertiesMap = {
  "content:guide_navigation_clicked": {
    "destination": string;
    "placement": string;
  };
  "content:guide_viewed": {
    "guide_slug": string;
    "audience_count": number;
  };
  "content:official_source_clicked": {
    "guide_slug": string;
    "source_name": string;
  };
  "content:guide_index_selected": {
    "guide_slug": string;
    "placement": string;
  };
  "content:guide_cta_clicked": {
    "guide_slug": string;
    "destination": string;
    "placement": string;
  };
  "course_added": {
    "source": "schedule_builder";
  };
  "course_removed": {
    "source": "schedule_builder";
  };
  "course_sniper:alert_action": {
    "action": "acknowledge" | "rearm" | "pause" | "unsubscribe";
    "outcome": "opened" | "cancelled" | "confirmed" | "failed";
    "recovery": "none" | "offline" | "closed" | "permission" | "expired" | "revoked" | "stale" | "unavailable";
  };
  "course_sniper:webreg_handoff": {
    "readiness": "verified";
    "network": "online";
  };
  "landing_cta_click": {
    "cta": string;
    "location": string;
    "module_id"?: string;
  };
  "landing_module_tab_click": {
    "module_id": string;
    "location": string;
  };
  "onboarding:completed": {
    "major_count": number;
    "transcript_imported": boolean;
    "year_selected": boolean;
  };
  "onboarding:skipped": {
    "step_number": number;
  };
  "optimal_setup:shown": {
    "entrypoint": "onboarding" | "settings";
  };
  "optimal_setup:previewed": {
    "entrypoint": "onboarding" | "settings";
    "item": "push_alerts" | "sms_alerts" | "location" | "calendar" | "widgets";
  };
  "optimal_setup:education_shown": {
    "entrypoint": "onboarding" | "settings";
    "item": "push_alerts" | "sms_alerts" | "location" | "calendar" | "widgets";
  };
  "optimal_setup:system_prompt": {
    "entrypoint": "onboarding" | "settings";
    "item": "push_alerts" | "location";
    "stage": "about_to_display" | "displayed" | "unavailable";
  };
  "optimal_setup:choice": {
    "entrypoint": "onboarding" | "settings";
    "item": "primary_schedule" | "active_term" | "commuter_preference" | "push_alerts" | "sms_alerts" | "location" | "calendar" | "widgets";
    "choice": "completed" | "dismissed";
  };
  "optimal_setup:permission_choice": {
    "entrypoint": "onboarding" | "settings";
    "item": "push_alerts" | "location";
    "choice": "granted" | "denied";
  };
  "optimal_setup:handoff": {
    "entrypoint": "onboarding" | "settings";
    "item": "calendar";
    "stage": "started" | "verified_downstream_use";
  };
  "optimal_setup:outcome": {
    "entrypoint": "onboarding" | "settings";
    "item": "checklist" | "primary_schedule" | "active_term" | "commuter_preference" | "push_alerts" | "sms_alerts" | "location" | "calendar" | "widgets";
    "outcome": "completed" | "skipped" | "denied" | "unavailable" | "recovery_opened";
  };
  "optimal_setup:completed": {
    "entrypoint": "onboarding" | "settings";
    "completed_count": number;
    "completion_kind"?: "finished" | "skipped_remaining";
  };
  "scarlet_search": {
    "query_length": number;
    "result_count": number;
    "scope": "all" | "courses" | "degrees" | "campus" | "schedules" | "people" | "events";
    "latency_ms": number;
  };
  "schedule:saved": {
    "course_count": number;
    "save_source": "generated_schedule" | "selected_schedule";
  };
  "schedule_generated": {
    "schedule_count": number;
    "total_courses": number;
    "pinned_classes": number;
    "generate_only_open": boolean;
    "preferences_set": boolean;
  };
  "search:result_selected": {
    "result_kind": "feature" | "setting" | "course" | "course-wiki" | "degree" | "schedule" | "course-list" | "event" | "person" | "campus" | "action" | "assistant" | "sirs" | "location" | "calculator";
    "selection_source": "primary" | "action";
  };
  "assistant:skill_observed": {
    "telemetry_schema_version": 1;
    "signal": "selection" | "clarification" | "completion" | "tool_failure" | "approval_rejection" | "retry" | "latency" | "abandonment";
    "skill_id": string;
    "skill_version": string;
    "latency_ms": number;
    "retry_count": number;
    "tool_name"?: string;
    "reason"?: string;
  };
  "transcript:import_confirmed": {
    "ap_credit_count": number;
    "course_count": number;
  };
  "user_logged_in": {
    "method": "google" | "email" | "password" | "oauth_other";
  };
};

export type AnalyticsEventProperties<N extends AnalyticsEventName> = AnalyticsEventPropertiesMap[N];

type EventPropertyRule = {
  readonly required: boolean;
  readonly type?: 'string' | 'integer' | 'number' | 'boolean';
  readonly enum?: readonly (string | number | boolean)[];
  readonly minimum?: number;
  readonly maximum?: number;
  readonly minLength?: number;
  readonly maxLength?: number;
  readonly pattern?: string;
};

const EVENT_PROPERTY_RULES: Record<AnalyticsEventName, Record<string, EventPropertyRule>> = {
  "content:guide_navigation_clicked": {
    "destination": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "placement": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "content:guide_viewed": {
    "guide_slug": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "audience_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    }
  },
  "content:official_source_clicked": {
    "guide_slug": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "source_name": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 120
    }
  },
  "content:guide_index_selected": {
    "guide_slug": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "placement": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "content:guide_cta_clicked": {
    "guide_slug": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "destination": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "placement": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "course_added": {
    "source": {
      "required": true,
      "enum": [
        "schedule_builder"
      ]
    }
  },
  "course_removed": {
    "source": {
      "required": true,
      "enum": [
        "schedule_builder"
      ]
    }
  },
  "course_sniper:alert_action": {
    "action": {
      "required": true,
      "enum": [
        "acknowledge",
        "rearm",
        "pause",
        "unsubscribe"
      ]
    },
    "outcome": {
      "required": true,
      "enum": [
        "opened",
        "cancelled",
        "confirmed",
        "failed"
      ]
    },
    "recovery": {
      "required": true,
      "enum": [
        "none",
        "offline",
        "closed",
        "permission",
        "expired",
        "revoked",
        "stale",
        "unavailable"
      ]
    }
  },
  "course_sniper:webreg_handoff": {
    "readiness": {
      "required": true,
      "enum": [
        "verified"
      ]
    },
    "network": {
      "required": true,
      "enum": [
        "online"
      ]
    }
  },
  "landing_cta_click": {
    "cta": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "location": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "module_id": {
      "required": false,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "landing_module_tab_click": {
    "module_id": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "location": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "onboarding:completed": {
    "major_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "transcript_imported": {
      "required": true,
      "type": "boolean"
    },
    "year_selected": {
      "required": true,
      "type": "boolean"
    }
  },
  "onboarding:skipped": {
    "step_number": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    }
  },
  "optimal_setup:shown": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    }
  },
  "optimal_setup:previewed": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "push_alerts",
        "sms_alerts",
        "location",
        "calendar",
        "widgets"
      ]
    }
  },
  "optimal_setup:education_shown": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "push_alerts",
        "sms_alerts",
        "location",
        "calendar",
        "widgets"
      ]
    }
  },
  "optimal_setup:system_prompt": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "push_alerts",
        "location"
      ]
    },
    "stage": {
      "required": true,
      "enum": [
        "about_to_display",
        "displayed",
        "unavailable"
      ]
    }
  },
  "optimal_setup:choice": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "primary_schedule",
        "active_term",
        "commuter_preference",
        "push_alerts",
        "sms_alerts",
        "location",
        "calendar",
        "widgets"
      ]
    },
    "choice": {
      "required": true,
      "enum": [
        "completed",
        "dismissed"
      ]
    }
  },
  "optimal_setup:permission_choice": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "push_alerts",
        "location"
      ]
    },
    "choice": {
      "required": true,
      "enum": [
        "granted",
        "denied"
      ]
    }
  },
  "optimal_setup:handoff": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "calendar"
      ]
    },
    "stage": {
      "required": true,
      "enum": [
        "started",
        "verified_downstream_use"
      ]
    }
  },
  "optimal_setup:outcome": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "item": {
      "required": true,
      "enum": [
        "checklist",
        "primary_schedule",
        "active_term",
        "commuter_preference",
        "push_alerts",
        "sms_alerts",
        "location",
        "calendar",
        "widgets"
      ]
    },
    "outcome": {
      "required": true,
      "enum": [
        "completed",
        "skipped",
        "denied",
        "unavailable",
        "recovery_opened"
      ]
    }
  },
  "optimal_setup:completed": {
    "entrypoint": {
      "required": true,
      "enum": [
        "onboarding",
        "settings"
      ]
    },
    "completed_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "completion_kind": {
      "required": false,
      "enum": [
        "finished",
        "skipped_remaining"
      ]
    }
  },
  "scarlet_search": {
    "query_length": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "result_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "scope": {
      "required": true,
      "enum": [
        "all",
        "courses",
        "degrees",
        "campus",
        "schedules",
        "people",
        "events"
      ]
    },
    "latency_ms": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 600000
    }
  },
  "schedule:saved": {
    "course_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "save_source": {
      "required": true,
      "enum": [
        "generated_schedule",
        "selected_schedule"
      ]
    }
  },
  "schedule_generated": {
    "schedule_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "total_courses": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "pinned_classes": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "generate_only_open": {
      "required": true,
      "type": "boolean"
    },
    "preferences_set": {
      "required": true,
      "type": "boolean"
    }
  },
  "search:result_selected": {
    "result_kind": {
      "required": true,
      "enum": [
        "feature",
        "setting",
        "course",
        "course-wiki",
        "degree",
        "schedule",
        "course-list",
        "event",
        "person",
        "campus",
        "action",
        "assistant",
        "sirs",
        "location",
        "calculator"
      ]
    },
    "selection_source": {
      "required": true,
      "enum": [
        "primary",
        "action"
      ]
    }
  },
  "assistant:skill_observed": {
    "telemetry_schema_version": {
      "required": true,
      "enum": [
        1
      ]
    },
    "signal": {
      "required": true,
      "enum": [
        "selection",
        "clarification",
        "completion",
        "tool_failure",
        "approval_rejection",
        "retry",
        "latency",
        "abandonment"
      ]
    },
    "skill_id": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "skill_version": {
      "required": true,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "latency_ms": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 600000
    },
    "retry_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "tool_name": {
      "required": false,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    },
    "reason": {
      "required": false,
      "type": "string",
      "minLength": 1,
      "maxLength": 80,
      "pattern": "^[a-z0-9][a-z0-9:_.-]*$"
    }
  },
  "transcript:import_confirmed": {
    "ap_credit_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    },
    "course_count": {
      "required": true,
      "type": "integer",
      "minimum": 0,
      "maximum": 100000
    }
  },
  "user_logged_in": {
    "method": {
      "required": true,
      "enum": [
        "google",
        "email",
        "password",
        "oauth_other"
      ]
    }
  }
};

export type AnalyticsEventValidationResult<N extends AnalyticsEventName> =
  | { ok: true; value: AnalyticsEventProperties<N> }
  | { ok: false; reason: string };

export function isAnalyticsEventName(value: string): value is AnalyticsEventName {
  return (ANALYTICS_EVENT_NAMES as readonly string[]).includes(value);
}

function validateProperty(name: string, value: unknown, rule: EventPropertyRule): string | null {
  if (rule.type === 'string' && typeof value !== 'string') return `${name} must be a string`;
  if (rule.type === 'boolean' && typeof value !== 'boolean') return `${name} must be a boolean`;
  if (rule.type === 'number' && (typeof value !== 'number' || !Number.isFinite(value))) return `${name} must be a finite number`;
  if (rule.type === 'integer' && (typeof value !== 'number' || !Number.isInteger(value))) return `${name} must be an integer`;
  if (rule.enum && !rule.enum.includes(value as string | number | boolean)) return `${name} is not an allowed value`;
  if (typeof value === 'number' && rule.minimum !== undefined && value < rule.minimum) return `${name} is below its minimum`;
  if (typeof value === 'number' && rule.maximum !== undefined && value > rule.maximum) return `${name} is above its maximum`;
  if (typeof value === 'string' && rule.minLength !== undefined && value.length < rule.minLength) return `${name} is too short`;
  if (typeof value === 'string' && rule.maxLength !== undefined && value.length > rule.maxLength) return `${name} is too long`;
  if (typeof value === 'string' && rule.pattern && !(new RegExp(rule.pattern)).test(value)) return `${name} has an invalid format`;
  return null;
}

/**
 * Validates the browser-safe PostHog property object before it is captured.
 * This intentionally rejects unknown fields instead of silently dropping them
 * so schema changes are explicit and reviewable.
 */
export function validateAnalyticsEvent<N extends AnalyticsEventName>(
  name: N,
  properties: unknown,
): AnalyticsEventValidationResult<N> {
  if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
    return { ok: false, reason: 'properties must be an object' };
  }

  const rules = EVENT_PROPERTY_RULES[name];
  const record = properties as Record<string, unknown>;
  for (const key of Object.keys(record)) {
    if (!Object.prototype.hasOwnProperty.call(rules, key)) {
      return { ok: false, reason: `unknown property: ${key}` };
    }
  }
  for (const [key, rule] of Object.entries(rules)) {
    const value = record[key];
    if (value === undefined) {
      if (rule.required) return { ok: false, reason: `missing required property: ${key}` };
      continue;
    }
    const failure = validateProperty(key, value, rule);
    if (failure) return { ok: false, reason: failure };
  }

  return { ok: true, value: record as AnalyticsEventProperties<N> };
}
